import { randNumber } from "@ngneat/falso";
import { CountryCode, IBANBuilder } from "ibankit";

export const IBAN_COUNTRIES = Object.keys(CountryCode).filter((key) =>
  isNaN(Number(key)),
);

export function generateIban(countryCode: string): string {
  const code = CountryCode[countryCode as keyof typeof CountryCode];
  if (code === undefined) {
    throw new Error(`Unsupported country code: ${countryCode}`);
  }
  return new IBANBuilder()
    .countryCode(code)
    .bankCode(randNumber({ min: 0, max: 999 }).toString().padStart(3, "0"))
    .accountNumber(
      randNumber({ min: 0, max: 99999999999999 }).toString().padStart(16, "0"),
    )
    .build()
    .toString();
}
